import { makeStyles } from '@material-ui/core/styles'

const resetPasswordStyles = makeStyles(theme => ({
  ResetPasswordDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 114px)',
  },
  ResetPasswordBox: {
    width: '100%',
    maxWidth: '500px',
    background: '#FFF',
    boxShadow: '0px 2px 10px #3F434714'
  },
  ResetPasswordTextBox: {
    fontWeight: 'bold',
    fontSize: '2.375em',
    padding: '0 40px',
    textAlign: 'left',
    color: '#335977'
  },
  flexSpaceBtw:
  {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  },
  container: {
    padding: '10px 40px 40px',
    textAlign: 'center',
    fontSize: '0.875em'
  },
  resetText: {
    textAlign: 'left',
    color: '#545455',
    fontSize: '14px',
  },
}))

export { resetPasswordStyles }